import React, { forwardRef } from "react";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";

const CustomButton = forwardRef((props, ref) => <Button ref={ref} {...props} variant="contained" />);

CustomButton.displayName = "CustomGreyButton";

export default withStyles((theme) => ({
  root: {
    color: "#26323C",
    backgroundColor: "#EDF2F9",
    borderRadius: 22,

    "&:hover": {
      backgroundColor: "rgba(237, 242, 249, 0.6)",
    },
  },
  contained: {
    "& .MuiButton-label": {
      fontWeight: 500,
      fontSize: 22,
      [theme.breakpoints.between(1024, 1320)]: {
        fontSize: 20,
      },
    },
  },
}))(CustomButton);
